exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ageVerificationModal__modalContent___2PeSJ {\n  padding: 20px; }\n", ""]);

// exports
exports.locals = {
	"modalContent": "ageVerificationModal__modalContent___2PeSJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AgeVerificationModal/ageVerificationModal.scss
// module id = 4159
// module chunks = 6